import React from 'react';
import Styles  from './About.module.scss';
import HomeStyles  from '../home/Home.module.scss';
import classnames from "classnames";
import imageLink from "../../images/smooth_profile.png";


interface AboutProps{
    theme:string;
    backgroundImageUrl:string;
}
const About = ({theme,backgroundImageUrl}:AboutProps) => {

    return (
                <div className={Styles.about_container}>
                    <div className={Styles.about}>
                        <div className={Styles.who_am_i}>
                            Who Am I ?
                        </div>
                        Hey! The Person on the right is me.<br/>
                        I am clicking since I was 10 years old. I have only one photograph of me in a family function from 2010 and in that also I am clicking someone else's picture.So basically I am into it for a lot of years with no knowledge. So I started learning about it in 2017 sideways. Now I can say I have some knowledge about it and rest my portfolio says. I dont get much time for this as I am a SDE in Bangalore but I still try to keep it alive.<br/>
                        I have used a lot of devices till 2018 but then onwards devices I have used and still using are :
                        <div className={Styles.devices_container}>
                        <div className={Styles.device_name}>- 📱 Samsung A7 2018</div>
                        <div className={Styles.device_name}>- 📱 Samsung S22</div>
                        <div className={Styles.device_name}>- 📷 Canon Rebel SL2</div>
                        </div>
                    </div>
                </div>

    )
}

export default About;

